import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		display: "flex",
		alignItems: "center",
		...shorthands.gap(tokens.spacingHorizontalL),
	},
});
